// Autoplay attribute was not working in Safari consistently (ios 18, iphone 13)
// this is extra  to ensure the video plays in Safari
if (!customElements.get('autoplay-video')) {
  class AutoplayVideo extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('video[autoplay]').forEach((video) => {
        if (video.offsetParent === null) {
          return
        }

        video.play().catch(() => {
          video.addEventListener('canplay', () => video.play().catch(() => {}), {
            once: true,
          })
        })
      })
    }
  }

  customElements.define('autoplay-video', AutoplayVideo)
}
